// @ts-ignore
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

export default defineNuxtPlugin((nuxtApp) => {
  onNuxtReady(async () => {
    nuxtApp.provide('bootstrap', bootstrap);
  });
});
